import { LowerCasePipe, TitleCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { MatCell, MatCellDef, MatColumnDef, MatHeaderCell, MatHeaderCellDef } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { NotificationDto } from '@workspace/data-types';
import {
  AvatarAuraComponent,
  BaseDataTableCoreComponent,
  DataTableComponent,
  LuxonDatePipe,
  SimpleChipComponent,
} from '@workspace/ng-aura';
import { NotificationColumnKey } from './abstract-notifications-data-table.component';
import { NotificationsDataTableFilterCoreComponent } from './filter/notifications-data-table-filter.component';

@Component({
  selector: 'core-notifications-data-table',
  templateUrl: './notifications-data-table.component.html',
  imports: [
    DataTableComponent,
    MatSort,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatSortHeader,
    MatButtonModule,
    MatCellDef,
    MatCell,
    LuxonDatePipe,
    TitleCasePipe,
    LowerCasePipe,
    MatIconModule,
    MatTooltipModule,
    NotificationsDataTableFilterCoreComponent,
    AvatarAuraComponent,
    RouterModule,
    SimpleChipComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationsDataTableCoreComponent extends BaseDataTableCoreComponent<
  NotificationDto,
  NotificationColumnKey
> {}
